import styled from "styled-components";
import Button from "../../components/utils/Button/Button";

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const RowSpaceBetween = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 16px;
  margin-left: -7px;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
`;

export const ModelTitle = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 26px;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.1px;
  white-space: nowrap;
`;

export const ModelStatus = styled.div``;

export const StatusBadge = styled.span`
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ConfigSection = styled.div`
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  @media (max-width: 768px) {
    flex: unset;
  }
`;

export const SectionTitle = styled.h3`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 1px;
  background: #142743;
  width: 100%;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  svg {
    width: 24px;
    height: 24px;
    path {
      stroke-width: 1.5;
    }
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 16px;
  width: 100%;
`;

export const TutorialLink = styled.button`
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;
  flex-direction: row;
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  cursor: pointer;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  line-height: 20px;

  svg {
    width: 20px;
    height: 20px;
    rotate: -180deg;
    path {
      stroke-width: 1.25;
    }
  }

  @media (max-width: 400px) {
    gap: 0;
    font-size: 13px;
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const LinkText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  line-height: 20px;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 400px) {
    font-size: 13px;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 32px;
`;

export const Label = styled.label`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const LabelUpload = styled.label`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: ${(props) => (props.$maxWidth ? "500px" : "unset")};
`;

export const TextInput = styled.input`
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  display: flex;
  height: 44px;
  width: 100%;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  &:focus {
    border-color: #2877d9;
  }
`;

export const TextAreaInput = styled.textarea`
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  display: flex;
  min-height: 88px;
  width: 100%;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;

  outline: none;
  font-weight: 500;
  letter-spacing: -0.21px;

  box-sizing: border-box;
  resize: vertical;

  &:focus {
    border-color: #2877d9;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 14px 16px;
  background: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.1)"};
  border: 1px solid
    ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.2)"};
  border-radius: 8px;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  font-size: 14px;
  box-sizing: border-box;
  resize: vertical;
  margin-bottom: 8px;

  &::placeholder {
    color: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.5)"};
  }

  &:focus {
    outline: none;
    border-color: #4deeea;
    box-shadow: 0 0 0 2px rgba(77, 238, 234, 0.2);
  }
`;

export const RequirementsSection = styled(ConfigSection)``;

export const RequirementTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  margin: 0 0 24px 0;
`;

export const RequirementText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.21px;
  opacity: 0.5;
`;

export const Text = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;

  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.21px;
  opacity: 0.8;
`;

export const LabelColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
`;

export const UploadCount = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.195px;
  display: flex;
  height: ${(p) => (p.$white ? "28px" : "24px")};
  padding: ${(p) => (p.$white ? "4px 16px" : "8px 12px")};
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  border: ${(p) => (p.$white ? "1px solid white" : "none")};
  background: ${(p) => (p.$white ? "transparent" : "#2d4a7e")};
  svg {
    width: 14px;
    height: 14px;
  }
`;

export const CostSection = styled.div`
  background: ${({ theme }) =>
    theme === "light" ? "rgba(67, 233, 123, 0.05)" : "rgba(67, 233, 123, 0.1)"};
  border: 1px solid rgba(67, 233, 123, 0.3);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  text-align: center;
`;

export const CostTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  margin: 0 0 16px 0;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 8px;
`;

export const OriginalPrice = styled.span`
  font-size: 32px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: line-through;
`;

export const UploadSection = styled.div`
  display: flex;

  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  align-self: stretch;

  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
`;

export const UploadCard = styled.div`
  border-radius: 16px;
  border: 1px dashed #414143;
  padding: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: rgba(255, 255, 255, 0.035);
  }
`;

export const UploadCard2 = styled.div`
  display: flex;
  height: 176px;
  padding: 44px 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px dashed #315480;
  background:
    linear-gradient(0deg, #142743 0%, #142743 100%),
    url(<path-to-image>) lightgray 50% / cover no-repeat;
`;

export const UploadDescriptionText = styled.span`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  letter-spacing: -0.408px;
  opacity: 0.5;
`;

export const LabelRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;
export const UploadText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: ${(props) => (props.$light ? "13px" : "18px")};
  font-weight: ${(props) => (props.$light ? 300 : 500)};
  line-height: ${(props) => (props.$light ? "18px" : "normal")};
  margin-top: ${(props) => (props.$light ? "-12px" : "0px")};
  opacity: ${(props) => (props.$light ? 0.56 : 1)};
  letter-spacing: ${(props) => (props.$light ? "0" : "-0.408px")};

  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 32px;
  border-top: 1px solid
    ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"};
`;

export const DeleteButton = styled(Button)``;

export const StartTrainingButton = styled.button`
  border-radius: 100px;
  background: #fff;
  display: flex;
  width: 186px;
  height: 44px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border: none;
  outline: none;

  cursor: pointer;
  color: #000;
  font-family: Figtree;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.08px;

  transition: all 0.3s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }
`;
export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  border-radius: 12px;
  border: 1px dashed #325682;
  background: #142743;
  gap: 8px;
  width: 100%;
`;

export const EmptyStateText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.08px;
  margin: 0;
`;

export const EmptyStateSubtext = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.21px;
  opacity: 0.6;
  margin: 0;
  text-align: center;
`;
export const FilePreviewGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  @media (max-width: 700px) {
    align-self: center;
    justify-content: center;
  }
`;

export const RemoveFileButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 0, 0, 0.8);
  }
`;

export const FileName = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: #fff;
  font-size: 10px;
  padding: 8px 4px 4px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PageLoader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 20px;
`;

export const LoaderText = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.08px;
  opacity: 0.7;
`;
export const SkeletonLoaderColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const SkeletonLoader = styled.div`
  background: linear-gradient(90deg, #152a47 0px, #23406a 40px, #152a47 80px);
  background-size: 300px 100%;
  animation: shimmer 8s infinite linear;
  border-radius: ${(props) => props.$radius || "8px"};
  height: ${(props) => props.$height || "20px"};
  max-width: ${(props) => props.$width || "100%"};
  width: 100%;

  @keyframes shimmer {
    0% {
      background-position: -300px 0;
    }
    100% {
      background-position: 300px 0;
    }
  }
`;

export const SkeletonSection = styled.div`
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
  padding: 16px;
  display: flex;
  height: ${(props) => props.$height || "335px"};
  max-height: ${(props) => props.$height || "335px"};
  flex-direction: column;
  gap: 16px;
  flex: 1 0 0;
`;

export const ImgContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const SelectionOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${(props) =>
    props.$selected ? "rgba(76, 156, 254, 0.15)" : "transparent"};
  border: 3px solid ${(props) => (props.$selected ? "#4c9cfe" : "transparent")};
  border-radius: 12px;
  pointer-events: none;
  transition: all 0.3s ease;
  z-index: 1;
`;

export const SelectButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${(props) =>
    props.$selected ? "#4c9cfe" : "rgba(0, 0, 0, 0.7)"};
  border: 3px solid
    ${(props) => (props.$selected ? "#fff" : "rgba(255, 255, 255, 0.6)")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  padding: 0;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

  &:active {
    transform: scale(0.9);
  }

  &:hover {
    transform: scale(1.05);
  }

  svg {
    width: 16px;
    height: 16px;
    color: white;
  }
`;

export const FilePreviewItem = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #142743;
  border: 1px solid #325682;
  outline: ${(props) =>
    props.$selected ? "2px solid #4c9cfe" : "2px solid transparent"};
  width: 170px;
  height: 220px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  @media (max-width: 500px) {
    width: 150px;
    height: 200px;
  }

  @media (max-width: 400px) {
    width: 130px;
    height: 170px;
  }
`;

export const FilePreview = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  svg {
    width: 40px;
    height: 40px;
    color: #fff;
    opacity: 0.5;
  }
`;

export const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const ProgressOverlay = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #142743 0%, #0b1727 100%);
`;
